import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { parseClasses } from '../../lib/ep.js';

import DisabledArea from './DisabledArea';
import FieldLabel from './FieldLabel';
import FileUploader from './FileUploader';
import VideoPicker from './VideoPicker';
import Radiobutton from './Radiobutton';

const MediaPicker = (props) => {
	const [ selected_type, setSelectedType ] = useState('photo');

	const changeOption = (new_option) => {
		setSelectedType(new_option);
	};

	const has_error = (props.errors && props.errors[props.name]) ? props.errors[props.name] : false;

	let classname = props?.classname ?? 'input media_picker';
	classname = parseClasses(classname, props._class, 'input');

	return (
		<div
			class={'react_field' + ((props._field_class != undefined) ? ' ' + props._field_class : '')}
			onMouseEnter={props.onMouseEnter}
			onMouseLeave={props.onMouseLeave}
			onFocus={props.onFocus}
			onBlur={props.onBlur}
			onClick={props.onClick}
			style={props._field_style}
		>
			<div class={classname + ((has_error) ? ' has_error' : '')} style={props._style}>
				{(props.children) && (
					<FieldLabel
						{...props.label_props}
						name={props.name}
						autotranslate={props.autotranslate}
					>{props.children}</FieldLabel>
				)}

				<div>
					<Radiobutton
						name="photo"
						checked={(selected_type == 'photo') ? true : false}
						change={() => changeOption('photo')}
					>Photo</Radiobutton>

					<DisabledArea
						disabled={(selected_type != 'photo') ? true : false}
					>
						<FileUploader
							{...props.image_props}
						/>
					</DisabledArea>
				</div>

				<div style={{ marginTop:'1em' }}>
					<Radiobutton
						name="video"
						checked={(selected_type == 'video') ? true : false}
						change={() => changeOption('video')}
					>Video</Radiobutton>

					<DisabledArea
						disabled={(selected_type != 'video') ? true : false}
					>
						<VideoPicker
							{...props.video_props}
						/>
					</DisabledArea>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(MediaPicker);